export default [{
  path: '/view/robot-documents',
  name: 'robotdocuments',
  component: () => import('@/app/robot-documents/RobotDocuments'),
  meta: { }
}]
